import router from '@/router'
import WechatAuth from '@/libs/wechat-auth'
import { checkSSO } from '@/api/user'
import { setToken, getToken, removeToken, setWXInfo, setUserInfo, getUserInfo } from '@/libs/cookie-storage'
import { AppType, varConfig, getSearchParams } from '@/utils'
import { sendPassport } from '@/libs/ds-bridge'
import url from 'url'
import querystring from 'querystring'

const wechatAuth = new WechatAuth({
  appid: varConfig.wxAppId // 微信appid
})

function checkPassportValidOld() {
  return new Promise((resolve, reject) => {
    checkSSO().then(response => {
      const data = response.data
      if (data && !data.session) {
        removeToken()
        resolve(false)
      } else {
        if (data.passport) {
          setToken(data.passport)
        }
        if (data.user) {
          setUserInfo(data.user)
        }
        resolve(true)
      }
    }).catch(error => {
      reject(error)
    })
  })
}

function checkPassportValid() {
  const passport = getToken()
  return new Promise((resolve, reject) => {
    if (!passport) {

    }
  })
}

function getPassportByWeChat(authCode) {
  return new Promise((resolve, reject) => {
    loginWechat(authCode).then(response => {
      const data = response.data
      if (data.passport) {
        setToken(data.passport)
      }
      if (data.openId && data.accessToken) {
        setWXInfo({
          openId: data.openId,
          accessToken: data.accessToken
        })
      }
      if (data.user) {
        setUserInfo(data.user)
      }
      resolve(data)
    }).catch(error => {
      reject(error)
    })
  })
}

function authHandleInWeChat() {
  const query = querystring.parse(url.parse(window.location.href).query)
  const code = query.code
  const authCode = wechatAuth.getAuthCode()
  if (code && !authCode) {
    wechatAuth.setAuthCode(code)
    getPassportByWeChat(code).then(response => {
      wechatAuth.removeUrlCodeQuery()
      window.eventBus.$emit('WechatAuth', response.passport)
    })
  } else if (!code && authCode) {
    wechatAuth.removeAuthCode() // 微信与bmb未绑定
    router.replace({name: 'Verify'})
  } else {
    wechatAuth.openAuthPage()
  }
}

export function getUserInfoFromNative() {
  return new Promise((resolve, reject) => {
    const query = getSearchParams()
    if (AppType.isInApp() && query && query.passport) { // TODO only in app
      setToken(query.passport)
      checkSSO().then(response => {
        const data = response.data
        if (data && !!data.session) {
          if (data.passport) {
            setToken(data.passport)
          }
          if (data.user) {
            setUserInfo(data.user)
          }
        }
        resolve(true)
      }).catch(error => {
        reject(error)
      })
    } else {
      resolve(true)
    }
  })
}

export function getPassport(pageName) {
  pageName = pageName || 'Login'
  return new Promise((resolve, reject) => {
    checkPassportValid().then(response => {
      if (response) {
        wechatAuth.removeAuthCode() // 通过微信获取passport成功
        const user = getUserInfo()
        const passport = getToken()
        if (pageName === 'Login') { // 正常Login页面逻辑的返回校验
          resolve(true)
        } else {
          router.replace({name: pageName})
          resolve(false)
        }
      } else {
        router.replace({name: pageName})
        resolve(false)
      }
    }).catch(error => {
      reject(error)
    })
  })
}

export function checkPassport() {
  const passport = getToken()
  if (!passport) {
    router.replace({name: 'Login'})
  }
}



// WEBPACK FOOTER //
// ./src/libs/passport.js